export default __webpack_public_path__ + "static/media/17.6cbb381d.jpg";